import script from "./pro.vue?vue&type=script&setup=true&lang=js"
export * from "./pro.vue?vue&type=script&setup=true&lang=js"

import "./pro.vue?vue&type=style&index=0&id=dbc220fe&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/carbon-space-admin-site-CI/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbc220fe"]])

export default __exports__